var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m90.49,14.94h-14.97l-10-10h-31.08l-10,10h-14.92C4.28,14.94,0,19.22,0,24.45v61.1c0,5.23,4.28,9.51,9.51,9.51h80.98c5.23,0,9.51-4.28,9.51-9.51V24.45c0-5.23-4.28-9.51-9.51-9.51Zm-40.49,65.24c-13.95,0-25.3-11.35-25.3-25.3s11.35-25.3,25.3-25.3,25.3,11.35,25.3,25.3-11.35,25.3-25.3,25.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m50,39.42c-8.52,0-15.46,6.93-15.46,15.46s6.93,15.46,15.46,15.46,15.46-6.93,15.46-15.46-6.93-15.46-15.46-15.46Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/CameraIcon.4a8d152110f431ccaae54d3ec87b2591.svg";
export { ForwardRef as ReactComponent };